/**
 * Fills in the Globo swatch app's color swatches with each variant's real
 * product photo. Globo renders `<li data-variantid="…">` swatch options with
 * an inline `background-color: transparent` when no color/image has been
 * configured on its side, leaving blank squares. This reads the per-variant
 * image data this theme embeds (see sections/main-product.liquid) and sets
 * a background-image on the matching swatch label, scoped to each product
 * section so it works with multiple product blocks on a page.
 */
(function () {
  'use strict';

  function applyImages(root) {
    var dataEl = root.querySelector('.variant-swatch-image-data');
    if (!dataEl) return;

    var imagesByVariantId;
    try {
      imagesByVariantId = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var labels = root.querySelectorAll('li[data-variantid] > label.swatch-anchor[style]');
    labels.forEach(function (label) {
      if (label.dataset.swatchImageApplied === 'true') return;

      var li = label.closest('li[data-variantid]');
      var variantId = li && li.getAttribute('data-variantid');
      var imageUrl = variantId && imagesByVariantId[variantId];
      if (!imageUrl) return;

      label.style.backgroundImage = 'url(' + imageUrl + ')';
      label.style.backgroundColor = '';
      label.dataset.swatchImageApplied = 'true';
    });
  }

  function applyToAllProducts() {
    document.querySelectorAll('product-info').forEach(applyImages);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyToAllProducts);
  } else {
    applyToAllProducts();
  }

  // Globo injects its swatch markup asynchronously after page load, so keep
  // watching for a short window and re-apply whenever new swatch nodes show up.
  var observer = new MutationObserver(function () {
    applyToAllProducts();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();
